import { render, staticRenderFns } from "./PhysicalCardListPane.vue?vue&type=template&id=40cc3b5e&scoped=true"
import script from "./PhysicalCardListPane.vue?vue&type=script&lang=js"
export * from "./PhysicalCardListPane.vue?vue&type=script&lang=js"
import style0 from "./PhysicalCardListPane.vue?vue&type=style&index=0&id=40cc3b5e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cc3b5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40cc3b5e')) {
      api.createRecord('40cc3b5e', component.options)
    } else {
      api.reload('40cc3b5e', component.options)
    }
    module.hot.accept("./PhysicalCardListPane.vue?vue&type=template&id=40cc3b5e&scoped=true", function () {
      api.rerender('40cc3b5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/gift_card/PhysicalCardListPane.vue"
export default component.exports